// IE11 fix
if (!window.location.origin) {
  // @ts-expect-error
  window.location.origin = `${window.location.protocol}//${
    window.location.hostname
  }${window.location.port ? `:${window.location.port}` : ''}`;
}
